import React from 'react';
import { Box, Typography } from '@mui/material';
import { useProviderHeaderStyles } from './styles';
import { MatchingProfileData } from '@uplift/api';
import { ProviderMedicalRole } from '@uplift/types';
import { useProviderRoleTitleLabel } from '../../selected-provider';

type ProviderHeaderProps = {
  providerName: string;
  pronouns?: string;
  stateId: string;
  licenses?: MatchingProfileData['licenses'];
  medicalRole?: ProviderMedicalRole;
};

export const ProviderHeader: React.FC<ProviderHeaderProps> = ({ providerName, pronouns, stateId, licenses = [], medicalRole }) => {
  const { classes } = useProviderHeaderStyles();
  const providerRole = useProviderRoleTitleLabel(
    medicalRole,
    licenses.filter(i => i.role.suffix).map(l => ({ id: l.role.id, name: l.role.suffix })),
    licenses.map(l => ({ id: l.id, name: l.role.name, stateId: l.stateId })),
    stateId,
  );

  return (
    <Box className={classes.root}>
      <Box className={classes.topLine}>
        <Box className={classes.name}>{providerName}</Box>
        {!!pronouns && <Typography variant="body2">({pronouns})</Typography>}
      </Box>
      <Typography color="textSecondary">
        {providerRole}
      </Typography>
    </Box>
  );
};
